"use strict";

if (!customElements.get('c-product-slider')) {
  customElements.define('c-product-slider', class ComponentProductSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = new Glide(this, {
        gap: 20,
        type: 'carousel',
        perView: 2.5,
        breakpoints: {
          600: {
            perView: 1
          },
          992: {
            perView: 2
          },
          1200: {
            perView: 2
          }
        }
      }).mount();
      this.slides = this.querySelectorAll(".js-product-slider__slides li");
    }
    connectedCallback() {
      this.slides.forEach(el => {
        el.addEventListener("click", ev => {
          ev.stopPropagation();
          publish("openSliderPopup", el);
        });
      });
    }
    disconnectedCallback() {}
  });
}
if (!customElements.get('c-product-slider-popup')) {
  customElements.define('c-product-slider-popup', class ComponentProductSliderPopup extends HTMLElement {
    constructor() {
      super();
      this.slider = new Glide(this.querySelector(".js-product-slider-popup__slider"), {
        gap: 20,
        type: 'carousel',
        perView: 1
      });
      this.slider.mount();
      this.slides = this.querySelectorAll(".js-product-slider-popup__slider li:not([class='glide__slide--clone']");
    }
    connectedCallback() {
      subscribe("openSliderPopup", el => this.openPopup(el));
      this.addEventListener("click", ev => this.closePopup(ev.target));
      document.body.addEventListener('keyup', e => {
        if (e.code == "Escape") {
          this.closePopup();
        }
      });
      this.videos = Array.from(this.querySelectorAll(".youtube-video"));
      this.slider.on(['move'], () => {
        this.querySelectorAll('.youtube-video').forEach(video => {
          video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        });
      });
    }
    disconnectedCallback() {
      this.removeEventListener("click", ev => this.closePopup(ev.target));
      document.body.removeEventListener('keyup', e => {
        if (e.code == "Escape") {
          this.closePopup();
        }
      });
    }
    openPopup(slide) {
      let order;
      this.slides.forEach((el, i) => {
        if (el.getAttribute("data-id") == slide.getAttribute("data-id")) {
          order = i;
          if (el.querySelector("iframe")) {
            el.querySelector("iframe").contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        }
      });
      document.body.classList.add("open");
      this.classList.add("active");
      this.slider.update({
        startAt: order,
        gap: 20,
        type: 'carousel',
        perView: 1
      });
    }
    closePopup() {
      let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
      if (el == this) {
        this.classList.remove("active");
        this.querySelectorAll('.youtube-video').forEach(video => {
          video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
        });
        document.body.classList.remove("open");
      }
    }
  });
}

// Deals tabs + coupon copy functionality for Main Product section
document.addEventListener('DOMContentLoaded', function () {
  const headerOffset = 75;
  const url = new URL(window.location.href);
  const shouldOpenDealTabFromParam = url.searchParams.get('open_deal_tab') === '1';
  const shouldOpenDealTabFromSession = window.sessionStorage.getItem('openDealTabAfterLogin') === '1';

  if (shouldOpenDealTabFromParam || shouldOpenDealTabFromSession) {
    if (window.location.hash !== '#deal-tab') {
      window.location.hash = '#deal-tab';
    }
    window.sessionStorage.removeItem('openDealTabAfterLogin');
    url.searchParams.delete('open_deal_tab');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${window.location.hash || '#deal-tab'}`);
  }

  function scrollToHashWithOffset(hash, smooth) {
    if (!hash) return;

    const id = hash.replace('#', '');
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: Math.max(top, 0),
      behavior: smooth ? 'smooth' : 'auto'
    });
  }

  document.querySelectorAll('.s-product-tabs-init').forEach(wrapper => {
    const tabs = wrapper.querySelectorAll('.s-product-tab');
    const items = wrapper.querySelectorAll('.s-product-tab-item');

    if (!tabs.length || !items.length) return;

    function activate(index) {
      tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
      });

      items.forEach((item, i) => {
        item.classList.toggle('is-active', i === index);
      });
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(index));
    });

    function activateFromHash(shouldScroll) {
      const hash = window.location.hash.replace('#', '');
      let indexFromHash = -1;

      if (hash) {
        items.forEach((item, index) => {
          if (item.id === hash) indexFromHash = index;
        });
      }

      activate(indexFromHash !== -1 ? indexFromHash : 0);

      if (shouldScroll && indexFromHash !== -1) {
        requestAnimationFrame(() => {
          scrollToHashWithOffset(`#${hash}`, false);
        });
      }
    }

    // 1) Первый рендер страницы (например, при переходе с карточки)
    activateFromHash(true);

    // 2) Переключение при клике по ссылкам с якорем вида href="#deal-tab"
    window.addEventListener('hashchange', () => {
      activateFromHash(true);
    });
  });

  document.querySelectorAll('.deal-header-title-link[href^="#"]').forEach(link => {
    link.addEventListener('click', function (event) {
      const hash = this.getAttribute('href');
      if (!hash) return;

      event.preventDefault();

      if (window.location.hash !== hash) {
        window.location.hash = hash;
        return;
      }

      window.dispatchEvent(new Event('hashchange'));
      scrollToHashWithOffset(hash, true);
    });
  });

  document.querySelectorAll('.deal-login-link').forEach(link => {
    link.addEventListener('click', function () {
      window.sessionStorage.setItem('openDealTabAfterLogin', '1');
    });
  });

  document.querySelectorAll('.copy-coupon-btn').forEach(button => {
    button.addEventListener('click', async function () {
      const wrapper = this.closest('.deal-redeem-coupon');
      if (!wrapper) return;

      const codeEl = wrapper.querySelector('.deal-redeem-coupon-code');
      if (!codeEl) return;

      const text = codeEl.textContent.trim();
      const originalLabel = this.textContent;

      try {
        await navigator.clipboard.writeText(text);
        this.textContent = 'Copied!';
        this.disabled = true;

        setTimeout(() => {
          this.textContent = originalLabel;
          this.disabled = false;
        }, 1500);
      } catch (err) {
        // fallback
        const temp = document.createElement('textarea');
        temp.value = text;
        document.body.appendChild(temp);
        temp.select();
        document.execCommand('copy');
        document.body.removeChild(temp);

        this.textContent = 'Copied!';
        setTimeout(() => {
          this.textContent = originalLabel;
        }, 1500);
      }
    });
  });
});